<div class="align-items-center">
  <p>Property Saved Successfully</p>
</div>
